import React from 'react'
import {
  Route,
  Switch,
  Redirect,
  Link,
  RouteComponentProps,
} from 'react-router-dom'
import { ComponentExt } from 'util/reactExt'
import UserPanel from 'containers/shared/UserPanel'
import UMessage from './UMessage'
import UCollection from './UCollection'
import UHistory from './UHistory'
import UStudyData from './UStudyData'
import styles from './style.scss'

export interface UserCenterProps extends RouteComponentProps<any> {}

const tabMap = [
  // {
  //   name: '我的学习馆',
  //   pathname: 'studyclub',
  //   component: UStudyClub,
  // },
  {
    name: '消息中心',
    pathname: 'message',
    component: UMessage,
  },
  {
    name: '收藏夹',
    pathname: 'collect',
    component: UCollection,
  },
  {
    name: '历史浏览',
    pathname: 'history',
    component: UHistory,
  },
  {
    name: '学习数据',
    pathname: 'data',
    component: UStudyData,
  },
]

class UserCenter extends ComponentExt<UserCenterProps, any> {
  renderTabMenu = () => {
    const { match, location } = this.props
    return (
      <ul className={styles.tabMenu}>
        {tabMap.map((tab, i) => (
          <li
            key={tab.pathname}
            className={`${styles.tabMenuItem} ${
              location.pathname.includes(tab.pathname)
                ? styles.tabMenuItemActive
                : ''
            }`}
          >
            <Link to={`/usercenter/${tab.pathname}`}>{tab.name}</Link>
          </li>
        ))}
      </ul>
    )
  }

  public render() {
    return (
      <div className={styles.userCenter}>
        <div className={styles.inner}>
          <section className={styles.leftSection}>
            {this.renderTabMenu()}
          </section>
          <section className={styles.rightSection}>
            <UserPanel history={this.props.history} />
            <Switch>
              {tabMap.map((tab, i) => (
                <Route
                  key={i}
                  path={`/usercenter/${tab.pathname}`}
                  component={tab.component}
                />
              ))}
              <Redirect to={`/usercenter/${tabMap[0].pathname}`} />
            </Switch>
          </section>
        </div>
      </div>
    )
  }
}

export default UserCenter
